import { render, staticRenderFns } from "./Coupons.html?vue&type=template&id=6f20c7e2&scoped=true&external"
import script from "./Coupons.js?vue&type=script&lang=js&external"
export * from "./Coupons.js?vue&type=script&lang=js&external"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=6f20c7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20c7e2",
  null
  
)

export default component.exports